import { Configuration, PopupRequest } from "@azure/msal-browser";
import { redirectUri, type TenantType, getTenantConfig } from "./azureAdConfig";

export const createMsalConfig = (tenant: TenantType): Configuration => {
    const tenantConfig = getTenantConfig(tenant);

    return {
        auth: {
            clientId: tenantConfig.clientId,
            authority: tenantConfig.authority,
            redirectUri: redirectUri || window.location.origin,
            postLogoutRedirectUri: redirectUri || window.location.origin,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: () => {},
            },
        },
    };
};

export const createLoginRequest = (tenant: TenantType): PopupRequest => {
    const clientId =
        tenant === "internal"
            ? import.meta.env.VITE_BACKEND_API_INTERNAL_CLIENT_ID
            : import.meta.env.VITE_BACKEND_API_EXTERNAL_CLIENT_ID;

    const scopeName =
        tenant === "internal"
            ? import.meta.env.VITE_BACKEND_API_INTERNAL_SCOPE
            : import.meta.env.VITE_BACKEND_API_EXTERNAL_SCOPE;

    return {
        scopes: [`api://${clientId}/${scopeName}`],
    };
};

export const loginRequest: PopupRequest = {
    scopes: ["openid", "profile", "email", "User.Read"],
};
